import { isEmpty } from 'lodash';

import { ReceptionServiceTableBean } from './ReceptionServiceInteractiveTable.types';

export const getCalculatedTotalPriceRange = (
   receptionServices: ReceptionServiceTableBean[]
): { min: number; max: number } => {
   const [firstReceptionService, ...restReceptionServices] = receptionServices;

   if (isEmpty(firstReceptionService)) {
      return { min: 0, max: 0 };
   }

   return restReceptionServices.reduce(
      (result, { receptionService }) => {
         result.min += receptionService.minPrice.asNumber();
         result.max += receptionService.maxPrice.asNumber();
         return result;
      },
      {
         min: firstReceptionService.receptionService.minPrice.asNumber(),
         max: firstReceptionService.receptionService.maxPrice.asNumber(),
      }
   );
};

export const getCalculatedTotalAdvancePaymentValue = (receptionServices: ReceptionServiceTableBean[]): number => {
   return receptionServices.reduce((total, { receptionService }) => {
      if (receptionService.advancePaymentValue) {
         return total + receptionService.advancePaymentValue.asNumber();
      }

      return total;
   }, 0);
};
